module.exports = __webpack_public_path__ + "img/history-00c5dcee.db2f775b.png";